import type {ReactElement} from 'react';
import React from 'react';
import type {ContextualMenuPaletteOptionProps} from './contextual-menu-palette-option.types';
import styles from './contextual-menu-palette-option.module.scss';
import {Option} from '@Components/contextual-menu/components/option';
import {IconBox, IconBoxSize} from '@Components/icon-box';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ColorPalette} from '@Components/color-palettes/color-palette/color-palette';
import {ColorPaletteSize} from '@Components/color-palettes/color-palette/color-palette.types';

export function ContextualMenuPaletteOption({className = '', ...props}: ContextualMenuPaletteOptionProps): ReactElement {
  const getColorPaletteIcon = (): ReactElement => {
    const icon = 'icon-plus';

    return <IconBox icon={icon} className={styles.icon} size={IconBoxSize.SMALL} iconSize={IconSize.SIZE_ICON_16} onClick={props.onClick} />;
  };

  const getOptionControlPalette = (): ReactElement => {
    return (
      <div className={styles.container}>
        <div className={styles.colorPaletteContainer}>
          <ColorPalette palette={props.appliedPalette} size={ColorPaletteSize.SMALL} onClick={props.onClick} />
          {getColorPaletteIcon()}
        </div>
      </div>
    );
  };

  return <Option tag={props.tag} key={props.id} className={className} label={props.label} optionControl={getOptionControlPalette()} />;
}
